import { onlyView } from "@/utils/onlyView.js";
import { getCookie } from "@/utils/support.js";
import { debounce } from "lodash";
import $ from "jquery";
import { QuotationDetailColumn, OrderDetailColumns } from "@/utils/columns";
import {
  customExportOrderToExcel,
  customExportQuotationToExcel,
  UserConfig,
  UserConfigSave,
} from "@/api/quotedPrice";
import { isDateSame } from "xe-utils/methods";
var newWin = function (href, id, atr) {
  //为防止window.open被浏览器拦截，此处使用a标签打开
  var a = document.createElement("a");
  a.setAttribute("href", href);
  a.setAttribute("target", "view_" + atr);
  a.setAttribute("id", id);
  // 防止反复添加
  if (!document.getElementById(id)) document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
  }, 100);
};
// 设置单页面公共部分
export default {
  computed: {
    getOnlyView() {
      return onlyView;
    },
  },
  data() {
    return {
      formSet: {},
      user: [],
      all: [],
      paramsSet: [],
      responseDataSet: [],
      user_config_module: "",
      user_config_name: "",
      RouteName: "",
    };
  },
  watch: {
    form: {
      handler(newValue) {
        this.formSet = newValue || {};

        // 确保 columns 存在且是数组
        if (!Array.isArray(this.columns)) {
          this.columns = [];
          return;
        }

        // 创建列的副本进行操作
        let filteredColumns = [...this.columns];

        if (
          this.formSet.order_type_id != 2 &&
          this.formSet.order_type_id != 3 &&
          this.formSet.order_type_id != 7
        ) {
          filteredColumns = filteredColumns.filter((item) => {
            return (
              item.key != "return_policy" &&
              item.key != "batch_no" &&
              item.key != "return_type"
            );
          });
        }

        if (this.formSet.is_forecast != 1) {
          filteredColumns = filteredColumns.filter((item) => {
            return item.key != "audit_status";
          });
        }

        this.columns = filteredColumns;
      },
      immediate: true,
      deep: true
    }
  },
  // watch: {
  //   immediate: true,
  //   form(newValue, pld) {
  //     this.formSet = newValue;
  //     if (
  //       this.formSet.order_type_id != 2 &&
  //       this.formSet.order_type_id != 3 &&
  //       this.formSet.order_type_id != 7
  //     ) {
  //       //退货订单才显示退货原因
  //       this.columns = this.columns.filter((item) => {
  //         return (
  //           item.key != "return_policy" &&
  //           item.key != "batch_no" &&
  //           item.key != "return_type"
  //         );
  //       });
  //     }
  //     if (this.formSet.is_forecast != 1) {
  //       this.columns = this.columns.filter((item) => {
  //         return item.key != "audit_status";
  //       });
  //     }
  //   },
  //   deep: true,
  // },

  methods: {
    /**
     * 全选
     * @param {*} val
     */
    handleCheckAll(val) {
      this.multipleSelection = val;
      if (val.length > 0) {
        var length = val.length;
        this.items_id = val[length - 1].quote_items_id;
      }
    },
    /**
     * 合计设置
     * @param event
     */
    changeSumBool(event) {
      let arr = [];
      this.columns = event;
      this.ListColumns = event
        .filter((item) => item.sum === true)
        .map((item) => item.key);
      event.forEach((item) => {
        arr.push({
          title: item.title,
          width: item.width,
          drag: item.drag,
          fixed:
            item.fixed !== undefined
              ? item.fixed == null
                ? "undefined"
                : item.fixed
              : false,
          sum: item.sum,
          key: item.key,
        });
      });
      if (this.RouteName === "ForecastApproval") {
        console.log("没保存");
      } else {
        this.debouncedSaveColumnOrder(arr);
      }
    },
    /**
     * 是否开启合计列
     * @param event
     */
    changeSumColumns(event) {
      this.sumShow = event;
    },
    /**
     * 右固定
     * @param event
     */
    rightFixed(event) {
      let arr = [];
      this.columns = event;
      event.forEach((item) => {
        arr.push({
          title: item.title,
          width: item.width,
          drag: item.drag,
          fixed:
            item.fixed !== undefined
              ? item.fixed == null
                ? "undefined"
                : item.fixed
              : false,
          sum: item.sum,
          key: item.key,
        });
      });
      if (this.RouteName === "ForecastApproval") {
        console.log("没保存");
      } else {
        this.debouncedSaveColumnOrder(arr);
      }
    },
    /**
     * 左固定
     * @param event
     */
    leftFixed(event) {
      let arr = [];
      this.columns = event;
      event.forEach((item) => {
        arr.push({
          title: item.title,
          width: item.width,
          drag: item.drag,
          fixed: item.fixed !== undefined ? item.fixed : false,
          sum: item.sum,
          key: item.key,
        });
      });
      if (this.RouteName === "ForecastApproval") {
        console.log("没保存");
      } else {
        this.debouncedSaveColumnOrder(arr);
      }
    },
    /**
     * 拖拽结束
     * @param event
     */
    onDragEndGet(event) {
      let arr = [];
      this.columns = event;
      console.log(event, "event");
      event.forEach((item) => {
        arr.push({
          title: item.title,
          width: item.width,
          drag: item.drag,
          fixed: item.fixed !== undefined ? item.fixed : false,
          sum: item.sum,
          key: item.key,
        });
      });
      if (this.RouteName === "ForecastApproval") {
        console.log("没保存");
      } else {
        this.debouncedSaveColumnOrder(arr);
      }
    },
    /**
     * 全选 隐藏显示 列头
     * @param event
     */
    changeGet(event) {
      let arr = [];
      this.columns = event;
      event.forEach((item) => {
        arr.push({
          title: item.title,
          width: item.width,
          drag: item.drag,
          fixed: item.fixed !== undefined ? item.fixed : false,
          sum: item.sum,
          key: item.key,
        });
      });
      if (this.RouteName === "ForecastApproval") {
        console.log("没保存");
      } else {
        this.debouncedSaveColumnOrder(arr);
      }
    },
    /**
     * 列设置取消某个列显示
     * @param event
     * @param title
     */
    changeBool(event, title, localSetting) {
      let arr = [];
      this.columns = localSetting;
      localSetting.forEach((item) => {
        arr.push({
          title: item.title,
          width: item.width,
          drag: item.drag,
          fixed: item.fixed !== undefined ? item.fixed : false,
          sum: item.sum,
          key: item.key,
        });
      });
      if (this.RouteName === "ForecastApproval") {
        console.log("没保存");
      } else {
        this.debouncedSaveColumnOrder(arr);
      }
    },
    /**
     * 切换单头
     */
    btnNoneBlock(name) {
      if (name === "generateQuotedPriceOrder") {
        this.buttonBool = !this.buttonBool;
        if (!this.buttonBool) {
          this.buttonTitle = "显示单头";
          this.buttonType = "info";
        } else {
          this.buttonTitle = "隐藏单头";
          this.buttonType = "warning";
        }
      } else if (name === "generateOrderDetail") {
        this.buttonBool = !this.buttonBool;
        if (!this.buttonBool) {
          this.buttonTitle = "显示单头";
          this.buttonType = "info";
        } else {
          this.buttonTitle = "隐藏单头";
          this.buttonType = "warning";
        }
      }
    },
    /**
     * 更新表格高度
     */
    // 你可以在你的 mixin 或组件的 methods 中添加这个辅助函数
    _getRefElement(refName) {
      const ref = this.$refs[refName];
      if (!ref) {
        return null;
      }
      // 如果 ref 是一个数组 (例如 v-for 中的 ref)，我们取第一个元素
      const refObject = Array.isArray(ref) ? ref[0] : ref;
      // 如果是组件实例，返回其 $el；否则直接返回 refObject (它应该是 DOM 元素)
      return refObject.$el || refObject;
    },

    _updateTableHeight(name) {
      if (name === "generateQuotedPriceOrder" || name === "generateOrderDetail") {
        this.$nextTick(() => {
          // 使用辅助函数安全地获取 DOM 元素
          const footerElement = this._getRefElement('Footer');
          const tableElement = this._getRefElement('filterTable');
          const headerElement = this._getRefElement('header');

          // 检查所有必需的元素是否都已成功获取
          if (footerElement && tableElement && headerElement) {
            const footerHeight = footerElement.offsetHeight;
            const tableTop = tableElement.offsetTop;

            // 同样，对 offsetParent 进行安全检查
            const parentTop = tableElement.offsetParent?.offsetTop || 0;

            this.tableHeight =
              window.innerHeight - tableTop - parentTop - footerHeight - 15;
            console.log("计算出的表格高度:", this.tableHeight);
          } else {
            // 详细的错误日志，方便调试
            console.warn(
              "计算表格高度失败：以下一个或多个 ref 未找到或不是有效的 DOM 元素:",
              {
                Footer: !footerElement,
                filterTable: !tableElement,
                header: !headerElement,
              }
            );
            // 可以选择一个默认高度或者不做任何事
            // this.tableHeight = 400;
          }
        });
      }
    },
    // _updateTableHeight(name) {
    //   if (name === "generateQuotedPriceOrder" || name === "generateOrderDetail") {
    //     this.$nextTick(() => {
    //       const footerElement = this.$refs.Footer;
    //       const tableElement = this.$refs.filterTable.$el;
    //       const headerElement = this.$refs.header.$el;
    //       if (footerElement && tableElement && headerElement) {
    //         const footerHeight = footerElement.offsetHeight;
    //         const tableTop = tableElement.offsetTop;
    //         const parentTop = tableElement.offsetParent.offsetTop || 0;
    //         this.tableHeight =
    //           window.innerHeight - tableTop - parentTop - footerHeight - 15;
    //         console.log("防抖后的高度:", this.tableHeight);
    //       }
    //     });
    //   }
    // },
    /**
     * 页面更新虚拟高度防抖处理
     */
    updateTableHeight: _.debounce(function (name) {
      this._updateTableHeight(name);
    }, 300),
    /**
     * 保存列
     * @param newVal
     */
    saveColumnOrder2120(newVal) {
      let data = newVal.map((column) => ({
        title: column.title,
        width: column.width,
        drag: column.drag,
        fixed: column.fixed,
        sum: column.sum,
        key: column.key,
      }));
      UserConfigSave({
        user_config_module: "2120",
        config_name: this.user_config_name,
        content: JSON.stringify(data),
      }).then((res) => {
        if (res.data.status === 200) {
          // this.$message.success(res.data.msg);
          // this.filterMethodData()
          // this.filterMethodData('Order')
        } else {
          this.$message.error("No Data");
        }
      });
    },
    /**
     * 保存列
     * @param newVal
     */
    saveColumnOrder2121(newVal) {
      let data = newVal.map((column) => ({
        title: column.title,
        width: column.width,
        drag: column.drag,
        fixed: column.fixed,
        sum: column.sum,
        key: column.key,
      }));
      UserConfigSave({
        user_config_module: "2121",
        config_name: this.user_config_name,
        content: JSON.stringify(data),
      }).then((res) => {
        if (res.data.status === 200) {
          // this.$message.success(res.data.msg);
          // this.filterMethodData().
          // this.filterMethodData('Detail')
        } else {
          this.$message.error("No Data");
        }
      });
    },
    /**
     * 导出
     * @param name
     */
    exportExcel(name) {
      // 1. 过滤需要导出的列
      let a = [];
      // 遍历数组 1，更新 export 值
      a = this.ColumnsChange.map((item1) => {
        // 在数组 2 中查找匹配的 title
        const matchedItem = this.data3.find(
          (item2) => item2.title === item1.title
        );
        // 如果找到匹配项，更新 export 值
        if (matchedItem) {
          return {
            ...item1,
            export: matchedItem.export,
          };
        }
        // 如果没有匹配项，返回原对象
        return item1;
      });
      a.forEach((item) => {
        this.newArr.push({
          title: item.title,
          export: item.export,
        });
      });
      this.exportColumns = a
        .filter((column) => column.export) // 筛选 checked: true 的列
        .map((column) => column.title); // 提取列字段
      this.keys = this.exportColumns
        .map((title) => {
          const item = this.columns.find((d) => d.title === title);
          return item ? item.key : null;
        })
        .filter((key) => key !== null); // 过滤掉未找到的 key
      const result = this.tableData.map((item) => {
        const newItem = {};
        this.keys.forEach((field) => {
          newItem[field] = item[field]; // 提取字段值
        });
        return newItem;
      });
      let data1 = {
        orders_id: this.orders_id,
        fields: this.keys,
        fieldNames: this.exportColumns,
      };
      let data = {
        quote_id: this.quote_id,
        fields: this.keys,
        fieldNames: this.exportColumns,
      };
      let body = {};
      if (name === "generateOrderDetail") {
        body = data1;
      } else if (name === "generateQuotedPriceOrder") {
        body = data;
      }

      UserConfigSave({
        user_config_module: this.userParams(name),
        config_name: this.TableExportConfigName(name),
        content: JSON.stringify(this.newArr),
      }).then((res) => {
        if (res.data.status === 200) {
          if (name === "generateOrderDetail") {
            customExportOrderToExcel(body).then((response) => {
              let objectUrl = response.data;
              const contentDisposition =
                response.headers["content-disposition"];
              let filename = "default.xlsx";

              if (contentDisposition) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(contentDisposition);
                if (matches != null && matches[1]) {
                  filename = matches[1].replace(/['"]/g, "");
                }
              }
              const blob = new Blob([objectUrl], {
                type: "application/vnd.ms-excel",
              });

              objectUrl = URL.createObjectURL(blob);
              const a = document.createElement("a");

              a.href = objectUrl;
              // //这里可以重新定义文件名，以前端为准
              a.download = filename;
              a.click();
              a.remove();
              URL.revokeObjectURL(objectUrl);
            });
          } else if (name === "generateQuotedPriceOrder") {
            customExportQuotationToExcel(body).then((response) => {
              const contentDisposition =
                response.headers["content-disposition"];
              let filename = "default.xlsx";

              if (contentDisposition) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(contentDisposition);
                if (matches != null && matches[1]) {
                  filename = matches[1].replace(/['"]/g, "");
                }
              }
              let objectUrl = response.data;
              const blob = new Blob([objectUrl], {
                type: "application/vnd.ms-excel",
              });
              objectUrl = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = objectUrl;
              // //这里可以重新定义文件名，以前端为准
              a.download = filename;
              a.click();
              a.remove();
              URL.revokeObjectURL(objectUrl);
            });
          }
          this.data3 = [];
          if (name === "generateOrderDetail") {
            if (this.user_config_name === "ORDER_RETURN_ITEMS_TABLE_HEADER") {
              this.GetUserConfigName();
            } else {
              this.filterMethodDataTwo(
                "generateOrderDetail",
                OrderDetailColumns.slice(1),
                2121,
                this.tableConfigName,
                OrderDetailColumns
              );
            }
          } else if (name === "generateQuotedPriceOrder") {
            // this.filterMethodData("Order");
            this.filterMethodDataTwo(
              "generateQuotedPriceOrder",
              QuotationDetailColumn.slice(1),
              2120,
              "QUOTE_ITEMS_TABLE_HEADER",
              QuotationDetailColumn
            );
          }
          this.modal13 = false;
        } else {
        }
      });
    },
    /**
     * 不同页面方法参数
     * @param name
     * @returns {string}
     */
    userParams(name) {
      if (name === "generateOrderDetail") {
        return "2121";
      } else if (name === "generateQuotedPriceOrder") {
        return "2120";
      }
    },
    /**
     * 导出excel配置名称
     * @param name
     * @returns {string}
     * @constructor
     */
    TableExportConfigName(name) {
      if (name === "generateOrderDetail") {
        //this.formSet.order_type_id, "formSet");
        if (
          this.formSet.order_type_id == 2 ||
          this.formSet.order_type_id == 3 ||
          this.formSet.order_type_id == 7 ||
          this.formSet.order_type_id == "2" ||
          this.formSet.order_type_id == "3" ||
          this.formSet.order_type_id == "7"
        ) {
          return "ORDER_RETURN_ITEMS_EXPORT";
        } else {
          return "ORDER_ITEMS_EXPORT";
        }
      } else if (name === "generateQuotedPriceOrder") {
        return "QUOTE_ITEMS_EXPORT";
      }
    },
    /**
     * 触发导出excel弹框
     * @param title
     * @param number
     */
    exportExcelDialog(title, number) {
      const company_id = Number(getCookie("company_id"));
      switch (title) {
        case "还原":
          if (number === 1) {
            this.columns = [...QuotationDetailColumn.slice(1)];
            this.sumFields(this.columns, this.all);
            this.allSumFalseSetTwo(this.columns);
          }
          if (number === 2) {

            if (this.form.source_module === "2130") {
              this.columns = [...OrderDetailColumns.slice(1)].filter(
                (column) => column.key !== "batch_no" && column.key !== "uprice"
              );
            } else {
              this.columns = [...OrderDetailColumns.slice(1)].filter(
                (column) =>
                  column.key !== "outbound_qty" &&
                  column.key !== "outbound_order_no"
              );
              // if(this.company_idData && this.company_idData !== '2' && this.company_idData !== 2) {
              //   this.columns = this.columns.filter((item) => item.key !== "send_date");
              // }
            }
            if (this.company_idData == '1') {
              this.columns = this.columns.filter(
                (item) => item.key !== "send_date"
              );
            }
            // this.filterSet('generateOrderDetail')
          } else {
            console.log('进来了吗');
            if (this.name === "generateQuotedPriceOrder") {
              this.columns = [...QuotationDetailColumn.slice(1)];
              this.sumFields(this.columns, this.all);
              // this.filterSet("Order");
              this.allSumFalseSetTwo(this.columns);
            } else if (this.name === "generateOrderDetail") {
              this.columns = [...OrderDetailColumns.slice(1)];
              this.sumFields(this.columns, this.all);
              this.filterSet("generateOrderDetail");
              this.allSumFalseSetTwo(this.columns);
            }
          }
          this.getsave() // 还原后保存

          break;
        case "按上次自定义导出当前":
        case "自定义导出全部":
          this.newArr = [];
          this.exportExcel();
          break;
        case "开启固定列可拖拽":
          this.isDragging = true;
          break;
        case "关闭固定列可拖拽":
          this.isDragging = false;
          break;
        case "列设置":
          this.modal13 = true;
          this.title = "列设置";
          if (number === "generateQuotedPriceOrder") {
            this.filterMethodDataTwo(
              "generateQuotedPriceOrder",
              QuotationDetailColumn.slice(1),
              2120,
              "QUOTE_ITEMS_TABLE_HEADER",
              QuotationDetailColumn
            );
            let QuotationDetailColumnArr = [...QuotationDetailColumn.slice(1)];
            this.columns = this.mergeUserAndDefaultConfigs(
              this.columns,
              QuotationDetailColumnArr
            );
            this.ColumnsChange = this.dataAutoComplete.filter(
              (item) => item.title !== "" && item.title !== "操作"
            );
            console.log(this.columns, " this.columns");
          } else if (number === "generateOrderDetail") {
            this.filterMethodDataTwo(
              "generateOrderDetail",
              OrderDetailColumns.slice(1),
              2121,
              this.tableConfigName,
              OrderDetailColumns
            );
            let OrderDetailColumnsArr = [...OrderDetailColumns.slice(1)];
            this.columns = this.mergeUserAndDefaultConfigs(
              this.columns,
              OrderDetailColumnsArr
            );
            this.filterSet("generateOrderDetail");
          } else if (number === "ForecastApproval") {
            this.filterMethodDataTwo(
              "ForecastApproval",
              this.columns,
              0,
              "",
              this.columns
            );
          }
          break;
        default:
          if (this.user_config_name === "ORDER_RETURN_ITEMS_TABLE_HEADER") {
            this.GetUserConfigName(title, "ORDER_RETURN_ITEMS_EXPORT");
          } else if (this.user_config_name === "QUOTE_ITEMS_TABLE_HEADER") {
            this.GetUserConfigName(title, "QUOTE_ITEMS_EXPORT");
          } else {
            this.GetUserConfigName(title, "ORDER_ITEMS_EXPORT");
          }

          this.modal13 = true;
          this.title = "批量自定义导出";
          this.data3 = [];
          this.newArr = [];
          break;
      }
    },
    getsave() {
      let arr = [];
      this.columns.forEach((item) => {
        arr.push({
          title: item.title,
          width: item.width,
          drag: item.drag,
          fixed: item.fixed !== undefined ? item.fixed : false,
          sum: item.sum,
          key: item.key,
        });
      });
      if (this.RouteName === "ForecastApproval") {
        console.log("没保存");
      } else {
        this.debouncedSaveColumnOrder(arr);
      }
    },
    /**
     *当前方法对ORDER_RETURN_ITEMS_TABLE_HEADER 特殊处理
     */
    GetUserConfigName(title, userConfigName) {
      const company_id = Number(getCookie("company_id"));
      UserConfig({
        user_config_module: this.user_config_module,
        config_name: userConfigName,
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.data == null) {
            this.ColumnsChange = this.dataAutoComplete.slice(1);
            // 应用条件过滤
            this.filterSet(title, this.dataAutoComplete);
            this.ColumnsChange = this.ColumnsChange.filter(
              (item) => item.title !== "" && item.title !== "操作"
            );
            if (this.form.source_module === "2130") {
              this.ColumnsChange = this.ColumnsChange.filter((item) => {
                return item.title !== "退货批次" && item.title !== "客户等级价";
              });
            } else {
              this.ColumnsChange = this.ColumnsChange.filter((item) => {
                return item.title !== "出库单号" && item.title !== "出库数量";
              });
            }
          } else {
            if (this.form.source_module === "2130") {
              let user = JSON.parse(res.data.data[0].content);
              console.log("user 2130", user);
              let removeItems = user
                .map((i) => i.title)
                .filter(
                  (i) =>
                    this.dataAutoComplete.map((j) => j.title).indexOf(i) < 0
                );
              let newItems = this.dataAutoComplete
                .map((i) => i.title)
                .filter((i) => user.map((j) => j.title).indexOf(i) < 0);
              user = user.filter((i) => removeItems.indexOf(i.title) < 0);
              newItems.forEach((i) =>
                user.push({
                  title: i,
                  export: false,
                })
              );
              this.ColumnsChange = user.filter(
                (item) => item.title !== "" && item.title !== "操作"
              );
              if (company_id === 2) {
                this.ColumnsChange = this.ColumnsChange.filter((item) => {
                  return item.title !== "销售 折让金额" && item.title !== "";
                });
              }

              if (
                this.form.order_type_id !== 2 &&
                this.form.order_type_id !== 3 &&
                this.form.order_type_id !== 7 &&
                this.form.order_type_id !== "2" &&
                this.form.order_type_id !== "3" &&
                this.form.order_type_id !== "7"
              ) {
                //退货订单才显示退货原因
                this.ColumnsChange = this.ColumnsChange.filter((item) => {
                  return (
                    item.title !== "退货原因" &&
                    item.title !== "退货批次" &&
                    item.title !== "退货类型"
                  );
                });
              }
              this.ColumnsChange = this.ColumnsChange.filter((item) => {
                return item.title !== "退货批次" && item.title !== "客户等级价";
              });
            } else {
              let user = JSON.parse(res.data.data[0].content);
              console.log("user 2130", user);
              let removeItems = user
                .map((i) => i.title)
                .filter(
                  (i) =>
                    this.dataAutoComplete.map((j) => j.title).indexOf(i) < 0
                );
              let newItems = this.dataAutoComplete
                .map((i) => i.title)
                .filter((i) => user.map((j) => j.title).indexOf(i) < 0);
              user = user.filter((i) => removeItems.indexOf(i.title) < 0);
              newItems.forEach((i) =>
                user.push({
                  title: i,
                  export: false,
                })
              );
              this.ColumnsChange = user.filter(
                (item) => item.title !== "" && item.title !== "操作"
              );
              if (company_id === 2) {
                this.ColumnsChange = this.ColumnsChange.filter((item) => {
                  return item.title !== "销售 折让金额" && item.title !== "";
                });
              }

              this.ColumnsChange = this.ColumnsChange.filter((item) => {
                return item.title !== "出库单号" && item.title !== "出库数量";
              });
              if (
                this.form.order_type_id !== 2 &&
                this.form.order_type_id !== 3 &&
                this.form.order_type_id !== 7 &&
                this.form.order_type_id !== "2" &&
                this.form.order_type_id !== "3" &&
                this.form.order_type_id !== "7"
              ) {
                //退货订单才显示退货原因
                this.ColumnsChange = this.ColumnsChange.filter((item) => {
                  return (
                    item.title !== "退货原因" &&
                    item.title !== "退货批次" &&
                    item.title !== "退货类型"
                  );
                });
              }
              console.log("this.ColumnsChange", this.ColumnsChange);
            }
          }
        } else {
        }
      });
    },
    /**
     *当前方法对不带ORDER_RETURN_ITEMS_TABLE_HEADER 处理
     */
    GetConfigName(RouteName, params, CompleteColumn) {
      console.log(
        RouteName,
        params,
        CompleteColumn,
        "RouteName,params,CompleteColumn"
      );
      UserConfig({
        user_config_module: this.user_config_module,
        config_name: this.user_config_name,
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.data == null) {
            this.columns = [...params];
            this.ColumnsChange = this.dataAutoComplete.slice(1);
            // 处理合计字段
            this.sumFields(this.columns, CompleteColumn);
            // 应用条件过滤
            this.filterSet(RouteName, this.dataAutoComplete);
            this.ColumnsChange = this.ColumnsChange.filter(
              (item) => item.title !== "" && item.title !== "操作"
            );
            if (this.form.source_module == "2130") {
              console.log("为null进来了");
              if (!this.columns.some((col) => col.title === "出库数量")) {
                this.columns.push({
                  title: "出库数量",
                  key: "outbound_qty",
                  minWidth: 170,
                  maxWidth: 170,
                  width: 170,
                  resizable: true,
                  sortable: true,
                  checked: true,
                  drag: true,
                  sum: false,
                });
              }
              if (!this.columns.some((col) => col.title === "出库单号")) {
                this.columns.push({
                  title: "出库单号",
                  key: "outbound_order_no",
                  minWidth: 170,
                  maxWidth: 170,
                  width: 170,
                  resizable: true,
                  sortable: true,
                  checked: true,
                  drag: true,
                  sum: false,
                });
              }
            } else {
              console.log("当前为null 没有2130");
              this.columns = this.columns.filter(
                (column) =>
                  column.key !== "outbound_qty" &&
                  column.key !== "outbound_order_no"
              );
            }
            console.log("columns", this.columns);
          } else {
            let arr = JSON.parse(res.data.data[0].content);
            let arSet = arr.map((item2) => {
              const matchedItem = params.find(
                (item3) => item3.title === item2.title
              );
              return {
                ...item2,
                ...(matchedItem && {
                  key: matchedItem.key,
                }), // 如果匹配到，添加 key
              };
            });
            this.columns = arSet.map((item) => {
              if (item.title === "") {
                return {
                  ...item,
                  type: "checkbox",
                  resizable: true,
                  align: "center",
                };
              } else if (item.title !== "") {
                return {
                  ...item,
                  resizable: true,
                  align: "center",
                  // key: item.key,
                };
              }
              return item;
            });
            this.user = this.dataAutoComplete;
            this.filterSet(RouteName, this.user);
            this.ColumnsChange = this.user.filter(
              (item) => item.title !== "" && item.title !== "操作"
            );
            this.allDragFalseSetDetail(this.columns, params, CompleteColumn);
            if (this.form.source_module == "2130") {
              console.log("进来了");
              if (!this.columns.some((col) => col.title === "出库数量")) {
                this.columns.push({
                  title: "出库数量",
                  key: "outbound_qty",
                  minWidth: 170,
                  maxWidth: 170,
                  width: 170,
                  resizable: true,
                  sortable: true,
                  checked: true,
                  drag: true,
                  sum: false,
                });
              }
              if (!this.columns.some((col) => col.title === "出库单号")) {
                this.columns.push({
                  title: "出库单号",
                  key: "outbound_order_no",
                  minWidth: 170,
                  maxWidth: 170,
                  width: 170,
                  resizable: true,
                  sortable: true,
                  checked: true,
                  drag: true,
                  sum: false,
                });
              }
            } else {
              console.log("当前没有2130");
              this.columns = this.columns.filter(
                (column) =>
                  column.key !== "outbound_qty" &&
                  column.key !== "outbound_order_no"
              );
            }

            if (RouteName === "generateQuotedPriceOrder") {
              let QuotationDetailColumnArr = [
                ...QuotationDetailColumn.slice(1),
              ];
              this.columns = this.mergeUserAndDefaultConfigs(
                this.columns,
                QuotationDetailColumnArr
              );
            }
            // this.filterSet(RouteName, this.user);
            console.log("columns", this.columns);
          }
        } else {
          console.log("请求失败");
        }
      });
    },
    /**
     * 根据标题获取对应的 key
     * @param titles
     * @param data
     * @returns {*}
     */
    getKeysByTitles(titles, data) {
      return titles
        .map((title) => {
          const foundItem = data.find((item) => item.title === title);
          return foundItem ? foundItem.key : null;
        })
        .filter((key) => key !== null);
    },
    /**
     * 计算合并获取字段方法
     */
    sumFields(columns, params) {
      const sumFields = columns
        .filter((item) => item.sum === true)
        .map((item) => item.title);
      /* 根据标题获取对应的 matchedKeys */
      this.ListColumns = this.getKeysByTitles(sumFields, params);
    },
    /**
     * allDragFalse 列设置Drag全部为false时关闭隐藏合计列
     */
    allDragFalseSetDetail(userHead, params, CompleteColumn) {
      const allDragFalse = userHead.every((item) => item.drag === false);
      if (allDragFalse) {
        this.columns = [...params];
      } else {
        // // 调用函数重新排序
        let OrderDetailColumnsArr = [...params];
        // 从数组a中提取title顺序
        const order = userHead.map((item) => item.title);
        // 按照数组a的顺序对数组b进行排序
        OrderDetailColumnsArr.sort((x, y) => {
          const xIndex = order.indexOf(x.title);
          const yIndex = order.indexOf(y.title);
          return xIndex - yIndex;
        });
        this.columns = this.reorderColumns(userHead, OrderDetailColumnsArr);
        const seen = new Set();
        this.columns = this.columns.filter((item) => {
          if (item.type === "checkbox") {
            const key = "checkbox"; // 用固定键标记 checkbox 类型
            if (seen.has(key)) return false;
            seen.add(key);
          }
          return true;
        });
      }
    },
    /**
     * allSumFalse 列设置Sum为false时关闭合计列
     */
    allSumFalseSetTwo(userHead) {
      const allSumFalse = userHead.every((item) =>
        item.hasOwnProperty("sum") ? item.sum === false : true
      );

      if (allSumFalse) {
        //"所有项的sum属性都为false");
        this.sumShow = false;
      } else {
        //"存在sum属性不为false的项");
        this.sumShow = true;
      }
    },
    /**
     *  初始化数据 Order Detail
     */
    filterSet(RouteName, dataAutoComplete) {
      console.log(RouteName, dataAutoComplete, "9999999999999");
      const company_id = Number(getCookie("company_id"));
      if (RouteName === "generateOrderDetail") {
        if (company_id === 2) {
          this.columns = this.columns.filter(
            (item) => item.key !== "sale_discount"
          );
          this.ColumnsChange = this.ColumnsChange.filter((item) => {
            return item.title !== "销售 折让金额";
          });
        }
        if (this.company_idData == '1') {
          this.columns = this.columns.filter(
            (item) => item.key !== "send_date"
          );
        }
        if (
          this.form.order_type_id != 2 &&
          this.form.order_type_id != 3 &&
          this.form.order_type_id != 7 &&
          this.form.order_type_id != "2" &&
          this.form.order_type_id != "3" &&
          this.form.order_type_id != "7"
        ) {
          //退货订单才显示退货原因
          if (this.form.source_module === "2130") {
            this.columns = this.columns.filter((item) => {
              return (
                item.key !== "return_policy" &&
                item.key !== "batch_no" &&
                item.key !== "return_type" &&
                item.key !== "uprice"
              );
            });
          } else {
            this.columns = this.columns.filter((item) => {
              return (
                item.key !== "return_policy" &&
                item.key !== "batch_no" &&
                item.key !== "return_type"
                // &&
                // item.key !== "send_date"
              );
            });
          }
        }
        if (this.form.is_forecast !== 1) {
          this.columns = this.columns.filter((item) => {
            return item.key !== "audit_status";
          });
        }
        if (dataAutoComplete) {
          this.user = dataAutoComplete;
          if (company_id === 2) {
            this.columns = this.columns.filter(
              (item) => item.key !== "sale_discount"
            );
            this.ColumnsChange = this.ColumnsChange.filter((item) => {
              return item.title !== "销售 折让金额";
            });
          }
          if (
            this.form.order_type_id !== 2 &&
            this.form.order_type_id !== 3 &&
            this.form.order_type_id !== 7 &&
            this.form.order_type_id !== "2" &&
            this.form.order_type_id !== "3" &&
            this.form.order_type_id !== "7"
          ) {
            //退货订单才显示退货原因
            this.ColumnsChange = this.user.filter((item) => {
              return (
                item.title !== "退货原因" &&
                item.title !== "退货批次" &&
                item.title !== "退货类型"
              );
            });
          } else {
            this.ColumnsChange = this.user;
          }
          if (this.form.is_forecast !== 1) {
            this.ColumnsChange = this.ColumnsChange.filter((item) => {
              return item.title !== "行审核 状态";
            });
          }
        } else {
          //"dataAutoComplete无数据");
        }
      }
    },
    /**
     * 根据路由名称过滤和处理表格列数据
     * @param {string} RouteName - 路由名称
     * @param {Array} params - 基础列配置参数
     * @param {string} user_config_module - 用户配置模块
     * @param {string} user_config_name - 用户配置名称
     * @param {Array} CompleteColumn - 完整列配置
     */
    filterMethodDataTwo(
      RouteName,
      params,
      user_config_module,
      user_config_name,
      CompleteColumn
    ) {
      // console.log(RouteName,params,user_config_module,user_config_name,CompleteColumn,'RouteName,params,user_config_module,user_config_name,CompleteColumn')
      this.user_config_name = user_config_name;
      this.user_config_module = user_config_module;
      this.all = CompleteColumn;
      this.paramsSet = params;
      this.RouteName = RouteName;
      // 初始化数据
      this.dataAutoComplete = [];
      this.columns = [];

      // 生成自动完成数据（用于导出列选择）
      this.dataAutoComplete = params.map((item) => ({
        title: item.title,
        export: item.checked || false, // 默认不选中
      }));
      if (this.user_config_name === "ORDER_RETURN_ITEMS_TABLE_HEADER") {
        this.GetConfigName(RouteName, params, CompleteColumn);
      } else {
        this.GetConfigName(RouteName, params, CompleteColumn);
      }
    },
    // ==================== 辅助方法 ====================
    /**
     * 合并用户配置和默认配置
     * @param {Array} userConfig - 用户配置
     * @param {Array} defaultConfig - 默认配置
     * @returns {Array} 合并后的配置
     */
    mergeUserAndDefaultConfigs(userConfig, defaultConfig) {
      // 去重用户配置
      const userData = Array.from(new Set(userConfig));
      const defaultTitles = defaultConfig.map((item) => item.title);

      // 过滤无效的用户配置项
      const validUserItems = userData.filter((item) =>
        defaultTitles.includes(item.title)
      );

      // 找出默认配置中缺失的项
      const missingItems = defaultConfig
        .filter((item) => !userData.some((u) => u.title === item.title))
        .map((item) => ({
          ...item,
          export: false,
          drag: false,
        }));
      //defaultConfig, "defaultConfig");
      return [...validUserItems, ...missingItems];
    },

    /**
     * 根据拖拽列宽保存 排序 替换长度
     * @param arr1
     * @param arr2
     * @returns {*}
     */
    reorderColumns(arr1, arr2) {
      return arr1
        .map((item) => {
          // 找到 arr2 中 title 相同的列
          const column = arr2.find((col) => col.title === item.title);
          return column
            ? {
              ...column,
              width: item.width,
              drag: item.drag !== undefined ? item.drag : true,
              fixed: item.fixed,
              sum: item.sum,
              // key: item.key
            }
            : null;
        })
        .filter(Boolean);
    },
    /**
     * 拖拽列宽保存
     * @param $table
     * @param column
     * @param newColumn
     * @param oldColumn
     */
    columnDragendEvent({ $table, column, newColumn, oldColumn }, name) {
      if (name === "generateOrderDetail") {
        const table = this.$refs.filterTable.$refs.tableRef;
        let b = [];
        if (table) {
          const tableColumn = $table.getFullColumns();
          tableColumn.forEach((column) => {
            OrderDetailColumns.forEach((item) => {
              if (column.title === item.title) {
                b.push({
                  title: column.title,
                  width: column.width,
                  drag: item.drag,
                  fixed: item.fixed !== undefined ? item.fixed : false,
                  sum: item.sum,
                  key: item.key,
                });
              }
            });
          });
          if (this.RouteName === "ForecastApproval") {
            console.log("没保存");
          } else {
            this.debouncedSaveColumnOrder(b);
          }
        }
      } else if (name === "generateQuotedPriceOrder") {
        const table = this.$refs.filterTable.$refs.tableRef;
        let b = [];
        if (table) {
          const tableColumn = $table.getFullColumns();
          tableColumn.forEach((column) => {
            QuotationDetailColumn.forEach((item) => {
              if (column.title === item.title) {
                // item.width = width;
                b.push({
                  title: column.title,
                  width: column.width,
                  drag: item.drag,
                  fixed: item.fixed !== undefined ? item.fixed : false,
                  sum: item.sum,
                  key: item.key,
                });
              }
            });
          });
          if (this.RouteName === "ForecastApproval") {
            console.log("没保存");
          } else {
            this.debouncedSaveColumnOrder(b);
          }
        }
      }
    },
    /**
     * 监听f11 是否为全屏
     * @param {*} event
     */
    handleF11Key(event) {
      if (event.key === "F11" || event.keyCode === 122) {
        event.preventDefault(); // 阻止默认F11行为
        console.log("进来了吗");
        // 手动切换全屏
        if (!this.isFullscreen) {
          const element = document.documentElement;
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
          }
        } else {
          const element = document.documentElement;
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitExitFullscreen) {
            element.webkitExitFullscreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
          }
        }
      }
    },
    /**
     * 更新全屏状态
     */
    updateFullscreenStatus() {
      // 更新全屏状态
      this.isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
      console.log("全屏状态变化:", this.isFullscreen);
    },
    /**
     * 拖拽列宽开始
     * @param column
     */
    columnDragstartEvent({ column }) { },
    /**
     * 拖拽列宽保存
     * @param column
     */
    handleResizetion({ column }) {
      const table = this.$refs.filterTable.$refs.tableRef;
      let b = [];
      if (table) {
        const columns = table.getColumns();
        columns.forEach((column) => {
          const width = table.getColumnWidth(column.property);
          this.columns.forEach((item) => {
            if (column.title === item.title) {
              b.push({
                title: column.title,
                width: width,
                drag: item.drag,
                fixed: item.fixed !== undefined ? item.fixed : false,
                sum: item.sum,
                key: item.key,
              });
            }
          });
        });
        // //////)(b,'b')
        if (this.RouteName === "ForecastApproval") {
          console.log("没保存");
        } else {
          this.debouncedSaveColumnOrder(b);
        }
      }
    },
    /**
     * 右键菜单
     * @param
     */
    handleContextMenu(a) {
      // 检查点击的元素是否包含表头类名
      const isHeader = a.target.closest(".vxe-table--header");
      if (isHeader) {
        // 是表头才执行你的右键菜单逻辑
        this.$refs.contextmenu.$refs.contextmenu.show({
          top: a.clientY,
          left: a.clientX,
        });
      } else {
        // 不是表头则阻止默认行为
        event.preventDefault();
      }
    },
    /**
     * 列上下拖拽导出
     * @param first
     * @param end
     */
    changeTableSort1(first, end) {
      /* 前端互换2条数据index 和 orderid */
      first = parseInt(first);
      end = parseInt(end);
      let tmp = this.ColumnsChange[first];
      if (first < end) {
        for (var i = first + 1; i <= end; i++) {
          this.ColumnsChange.splice(i - 1, 1, this.ColumnsChange[i]);
        }
        this.ColumnsChange.splice(end, 1, tmp);
      }
      if (first > end) {
        for (var j = first; j > end; j--) {
          this.ColumnsChange.splice(j, 1, this.ColumnsChange[j - 1]);
        }
        this.ColumnsChange.splice(end, 1, tmp);
      }
    },
    /**
     * 切换全选
     * @param checked
     */
    toggleAllSelection(checked) {
      this.ColumnsChange = this.ColumnsChange.map((item) => ({
        ...item,
        export: checked,
      }));
    },
    /**
     * 设置localStorage
     *  @param {string} atr 需储存的属性
     */
    changeStroge(atr) {
      // 设置动态 localStorage属性值 用于监听
      localStorage.setItem(atr, this.$route.path + "," + new Date().getTime());
    },
    /**
     * 设置localStorage 并打开页面
     *  @param {string} path 需打开的页面路径
     *  @param {string} atr 需储存的属性
     */
    openAndSetView(path, atr) {
      let { href } = this.$router.resolve({
        path: path,
      });
      // //////)('href0',href);
      // //////)('path0',path);
      // if(!String(href).includes(Path)){
      // 	href = path;
      // 	if(String(href)[0]!='#'){
      // 		href = '#'+href;
      // 	}
      // }
      //////)('href',href);
      //////)('path',path);
      // window.open(href, "view_" + atr);
      newWin(href, new Date().getTime(), atr);
      // //////)('atr', atr);
      // 设置动态 localStorage 属性值 用于监听
      localStorage.setItem(atr, this.$route.path + "," + new Date().getTime());
    },
  },
};



// WEBPACK FOOTER //
// ./src/common/mixin/onlyViewMixin.js